import styled from 'styled-components';

import { TUnorderedListProperties } from '.';

export const StyledAccountNavigationMenu = styled.ul<TUnorderedListProperties>`
    display: ${({ isMenuOpen }) => (isMenuOpen ? `flex` : `none`)};
    flex-flow: column;
    margin: 0;
    padding: 0;
    list-style: none;

    @media (min-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletLandscapeMinimum}) {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }
`;
